import {
  getRequest,
  postJsonRequest,
  putJsonRequest,
  deleteJsonRequest,
  postFormRequest,
  loginRequest
} from "@/utils/api";
import { uri } from "@/api/uri/dpcUri/dpcManage";

import Toast from "@/utils/toast";
import { timeStampToDate, numberFormat } from "@/utils/index";
import calc from "@/lib/calc/index";

export function getMenuAndOrderByCard (params,option) {
  return new Promise((resolve, reject) => {
    getRequest(uri.dpcManage.getByCard, params,option).then(resp => {
      resolve(resp)
    }).catch(err => {
      reject(err)
    })
  })
}


export function getSysDict () {
  return new Promise((resolve, reject) => {
    getRequest(uri.dpcManage.sysDict, {}, {
      middleware: true,
      rootData: true
    }).then(resp => {
      resolve(resp)
    }).catch(err => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/dpcManage/dpcManage.js